module.exports = ngModule => {
  require('./formlyNgModelAttrsManipulator')(ngModule);
  require('./formlyCustomTags')(ngModule);
};



/** WEBPACK FOOTER **
 ** ../~/jshint-loader!./run/index.js
 **/